import {
  ClaimType, MAX_UPLOAD_FILE_NUM, MAX_UPLOAD_FILE_SIZE,
} from '@constants';

export const TITLE_TEXT = 'Please provide details';
export const MAX_UPLOAD_AMOUNT_LIMIT = 300;

export const MODAL_TITLE = {
  radio: '1. Why do you want to return the item?',
  upload: '2. Upload photos',
  remark: '3. Add additional comments. (optional)',
};
export const UPLOAD_TIP = `Maximum upload file size: ${MAX_UPLOAD_FILE_SIZE}MB, ${MAX_UPLOAD_FILE_NUM} files at most.`;

export const helpDocLink = {
  [ClaimType.Damage]: 'https://kover2618.zendesk.com/hc/en-us/articles/15392457332123-What-Supporting-Docs-are-Required-for-a-Claim-of-Damage-',
  [ClaimType.Loss]: 'https://kover2618.zendesk.com/hc/en-us/articles/15392585272603-What-Supporting-Docs-are-Required-for-a-Claim-of-Loss-',
  [ClaimType.Theft]: 'https://kover2618.zendesk.com/hc/en-us/articles/15392190225819-What-Supporting-Docs-are-Required-for-a-Claim-of-Theft-',
  Policy: 'https://kover2618.zendesk.com/hc/en-us/articles/15391881254427-How-to-File-a-Police-Report',
  Title: 'https://kover2618.zendesk.com/hc/en-us/sections/15653294528155-Shipping-Protection',
};

export const UPLOAD_HELP_TEXT = 'Please upload at least 1 file, maximum 10 files. Zip your files if you have more than 10. Maximum file size: 20MB.';

export const uploadInfoMap = {
  [ClaimType.Loss]: [{
    title: '1. Please upload the delivery note provided by the merchant corresponds to the packing slip.',
    helpText: UPLOAD_HELP_TEXT,
    isRequired: true,
    moreLink: helpDocLink[ClaimType.Loss],
    moreText: 'supporting docs required for your loss claim',
  }],
  [ClaimType.Theft]: [{
    title: '1. Please upload the delivery note provided by the merchant corresponds to the packing slip.',
    helpText: UPLOAD_HELP_TEXT,
    isRequired: true,
    showPoliceMore: true,
    moreLink: helpDocLink.Policy,
    moreText: 'how to file a police report',
  }, {
    title: '2. Please provide the police report for your case of theft.',
    helpText: UPLOAD_HELP_TEXT,
    isRequired: true,
    moreLink: helpDocLink[ClaimType.Theft],
    moreText: 'supporting docs required for your Theft claim',
  }, {
    title: '3. Other (e.g., security footage, carrier letter, or any written documentation from an authority/leasing office detailing the incident. These are optional, but thorough details help us expedite your payout.)',
    helpText: UPLOAD_HELP_TEXT,
    moreLink: helpDocLink[ClaimType.Theft],
    moreText: 'supporting docs required for your Theft claim',
  }],
};

// common upload 即loss和theft都用统一上传 所以文案一致
export const UploadText = {
  [ClaimType.Theft]: '1. Upload supporting documents like Police Report/ Security Footage/ Carrier Letter/ Written Documentation from an authority detailing the incident. Learn more about ',
  [ClaimType.Damage]: '1. To qualify for a payout for damaged item(s), please upload at least: 1) a photo of carrier\'s packaging; 2) a photo of product packaging; 3) a photo clearly showing the damage.',
  [ClaimType.Loss]: "1. Please upload a screenshot of the corresponding order page. If the shipment has shown “delivery” scan, but you didn't receive your package, you need to additionally provide one of the following: Police Report/ Security Footage/ Carrier Letter/ Written Documentation from an authority detailing the incident. Learn more about ",
};

// export const UploadCommentText = {
//   [ClaimType.Theft]: '1. Please upload any of the following to verify your claim of theft: 1) Police report; 2) Security footage; 3) Carrier letter; 4) Written documentation from an authority/leasing office.',
//   [ClaimType.Damage]: '1. Please upload clear photo(s) of the carrier packaging and product package',
//   [ClaimType.Loss]: '1. Please upload a screenshot of your Order Page that includes the Tracking Number, and a screenshot of its latest tracking update',
// };
